import { Component, Input, OnInit } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../../../lib/constants/reference-data-option-lists';
import { ReferenceData } from '../../../../../lib/models/reference-data.model';
import { BaseFormControlComponent } from '../../../../shared/components/form-inputs/base-form-control.component';
import { FormSelectableOption } from './models/form-selectable-option.model';

@Component({
  selector: 'boi-form-checkbox-list',
  templateUrl: './form-checkbox-list.component.html',
  styleUrls: ['./form-checkbox-list.component.scss']
})
export class FormCheckboxListComponent extends BaseFormControlComponent implements OnInit {
  referenceDataOptionLists = ReferenceDataOptionLists;
  referenceDataLabels = ReferenceDataLabels;

  @Input() public collection: Array<Object>;
  @Input() public availableOptions: Array<ReferenceData>;
  @Input() public rootPropertyName: string;
  @Input() public codePropertyName: string;
  @Input() public detailsPropertyName: string;
  @Input() public detailsLabelName: string;
  @Input() public areDetailsRequired: Function;

  public selectableOptions: Array<FormSelectableOption>;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.value = this.collection;
    this.selectableOptions = this.availableOptions.map((referenceData) => new FormSelectableOption(referenceData));

    this.selectableOptions.forEach((option) => {
      const selectedItem = this.findOptionByValue(option.Code);
      if (selectedItem !== undefined) {
        this.setSelectedOption(option, selectedItem);
      }
    });
  }

  private setSelectedOption(option: FormSelectableOption, selectedItem: Object): void {
    option.setSelectedItem(selectedItem);
    this.setDetailsRequiredFlag(option);
  }

  private setDetailsRequiredFlag(option: FormSelectableOption): void {
    option.AreDetailsRequired = this.areDetailsRequired !== undefined && this.areDetailsRequired(option);
  }

  private findOptionByValue(code: string): Object {
    const filteredOptions = this.collection.filter((item) => item[this.codePropertyName] === code);
    if (filteredOptions.length > 0) {
      return filteredOptions[0];
    }

    return undefined;
  }

  updateCheckbox(option: FormSelectableOption): void {
    if (option.Selected) {
      this.addNewOptionToValueArray(option);
    } else {
      this.removeOptionFromValueArray(option);
    }
  }

  private addNewOptionToValueArray(option: FormSelectableOption): void {
    const newItem = new Object();
    newItem[this.codePropertyName] = option.Code;
    newItem[this.detailsPropertyName] = undefined;
    this.setSelectedOption(option, newItem);
    this.collection.push(newItem);
  }

  private removeOptionFromValueArray(option: FormSelectableOption): void {
    const index = this.getOptionIndex(option);
    if (index > -1) {
      this.collection.splice(index, 1);
      option.Item = undefined;
    }
  }

  public getOptionIndex(option: FormSelectableOption): number {
    return this.collection.indexOf(option.Item);
  }
}
